import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HeaderComponent } from '@components/header/header.component';
import { MenuComponent } from '@components/menu/menu.component';
import { Scope3Component } from '@pages/dashboards/scope-3/scope-3.component';
import * as MdsIcons from '@mds/icons';
import { MdsIconsRegistryService } from '@mds/icons';
import { AngularSplitModule } from 'angular-split';
import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

export const tooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 300,
  hideDelay: 300,
  touchendHideDelay: 1500
};

const icons = Object.keys(MdsIcons)
  .map((key) => (MdsIcons as any)[key])
  .filter((icon) => icon && typeof icon === 'object' && Object.keys(icon).length > 0);

@NgModule({
  imports: [
    CommonModule,
    LayoutRoutingModule,
    MatSnackBarModule,
    HeaderComponent,
    MenuComponent,
    Scope3Component,
    AngularSplitModule,
    LayoutComponent,
  ],
  providers: [
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class LayoutModule {
  constructor(private mdsIconsRegistryService: MdsIconsRegistryService) {
    this.mdsIconsRegistryService.registerIcons([...icons]);
  }
}
